import Vue from 'vue';
import axios from 'axios'
import { Toast } from 'vant';
import Qs from 'qs'

Vue.use(Toast);

var token = window.localStorage.getItem('token');
// dev环境
 //var http_url = 'https://gmwuye.hybuss.cn/gzh-intelligent-power';
 //正式环境
 var http_url = 'https://hxwuye.hao-yong.cn/gzh-intelligent-power';
 //var http_url = 'http://192.168.3.100:9090';
var lineToken = getParam('token');
// console.log(token)

if(lineToken){
    window.localStorage.setItem('token',lineToken);
    token = lineToken;
    let iUrl = window.location.href;
    let lineUrl = iUrl.split('?');
    window.location.href = lineUrl[0];
}

function getParam(val){
    var url = window.location.href;
    var urls = url.split('?');
    if(urls[1]){
        var param = urls[1].split('&');
        for(var i=0;i<param.length;i++){
            var pam = param[i].split('=');
            if(pam[0] == val){
                return pam[1]
            }
        }
    }else {
        return
    }
}

// window.localStorage.removeItem('token')
// alert(token)
if(!token){
    console.log(token)
    loginFun()
}

function loginFun(){
    window.location.href = http_url + '/gzhWxApiController/login?url=' + window.location.href
}

// 请求接口
const request = function(hasToken,method,url,iData){
    let header = hasToken == 'token' ? {'token':token} : {};
    const instance = axios.create({
        baseURL:http_url,
        headers: header,
    });
    instance.interceptors.request.use(
        config => {
            Toast.loading({forbidClick:true,duration:0});
            // console.log(config)//请求头数据,一定要return config返回数据，不然报错
            return config
        },
        err => {
            return Promise.reject(err)
        }
    )
    instance.interceptors.response.use(
        response => {
            Toast.clear()
            // console.log(response)//成功回调数据
            //response 是成功数据，返回给instance用(instance.post成功就是应用这里返回的数据),如果return Promise.resolve(response) 其他地方调用if(res.data.status == 200)
            // 如果return Promise.resolve(response.data) 其他地方调用if(res.status == 200)
            return Promise.resolve(response)
        },
        error => {
            Toast.clear()
            return Promise.reject(error.response)
        }
    )
    if(method == 'post'){
        return new Promise(function(resolve,reject){
            instance.post(url,Qs.stringify(iData)).then((res)=>{
                resolve(res)
            }).catch((err)=>{
                reject(err)
            })
        })
    }else if(method == 'get'){
        return new Promise(function(resolve,reject){
            instance.get(url,{
                params:iData
            }).then((res)=>{
                resolve(res)
            }).catch((err)=>{
                reject(err)
            })
        })
    }
}

// 后端返回状态处理
const resetDataFun = function(res,callback){
    if(res.data.status == 200){
        callback&&callback()
    }else if(res.data.status == 400){
        Toast({message:'登录超时',duration:2000,forbidClick:true,onClose(){
            loginFun()
        }});
    }else{
        Toast({message:res.data.msg,forbidClick:true});
    }
}

export default {
    http_url,
    token,
    loginFun,
    request,
    resetDataFun
}